/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import nexumLogo2 from "../../assets/nexumLogo2.png";
import { DEFAULT_USER_ROLE } from "../../../utils/userUtils";

const messageWarning1 =
  "Non è possibile aggiornare perché il formato della mail nonb è corretto";
const messageWarning2 =
  "Non è possibile aggiornare perché i parametri inseriti sono già stati salvati";

const Sidebar = () => {
  const navigate = useNavigate();
  const userRole = parseInt(
    window.localStorage.getItem("role") || DEFAULT_USER_ROLE,
    10
  );

  const isUser = (window.localStorage.getItem("isUser") === "true");
  const isTenantUser = (window.localStorage.getItem("isTenantUser") === "true");

  const organizzazioniMenuItem = () => {
    if (userRole === 0) {
      return (
        <>
          <li className="flex flex-row align-middle p-2 border border-transparent rounded-lg hover:bg-light-blue">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              className="w-8 h-8 mr-2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            </svg>
            <Link to="/private/tenantlist">
              <span className="text-xl font-bold capitalize text-white">
                organizzazioni
              </span>
            </Link>
          </li>
          <li className="flex flex-row align-middle p-2 border border-transparent rounded-lg hover:bg-light-blue">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              className="w-8 h-8 mr-2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            </svg>
            <Link to="/private/userlist">
              <span className="text-xl font-bold capitalize text-white">
                Lista Utenti
              </span>
            </Link>
          </li>
        </>
      );
    }

    // if (userRole === 1) {
    //   return (
    //     <li className="flex flex-row align-middle p-2 border border-transparent rounded-lg hover:bg-light-blue">
    //       <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         strokeWidth="1.5"
    //         stroke="white"
    //         className="w-8 h-8 mr-2"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
    //         />
    //       </svg>
    //       <Link to="/private/detailstenant">
    //         <span className="text-xl font-bold capitalize text-white">
    //           organizzazione
    //         </span>
    //       </Link>
    //     </li>
    //   );
    // }
    return (
      <>
        {!isTenantUser && (
          <li className="flex flex-row align-middle p-2 border border-transparent rounded-lg hover:bg-light-blue">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              className="w-8 h-8 mr-2 my-auto"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 14l9-5-9-5-9 5 9 5z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 12l9 5 9-5"
              />
            </svg>
            {
              isUser ?
                (
                  <Link to="/private/userProfile">
                    <span className="text-xl font-bold capitalize text-white">
                      User's Profile
                    </span>
                  </Link>
                ) :
                (
                  <Link to="/private/multidetailstenant">
                    <span className="text-xl font-bold capitalize text-white">
                      Organizzazione
                    </span>
                  </Link>
                )
            }
          </li>
        )}
      </>
    );
  };

  return (
    <aside
      className="fixed top-0 left-0 z-40 w-2/12 h-screen pt-4 transition-transform -translate-x-full bg-dark-blue border-r border-white sm:translate-x-0"
      aria-label="Sidebar"
    >
      <div className="flex justify-center">
        <img className="w-8/12" src={nexumLogo2} alt="nexumLogo" />
      </div>
      <div className="flex justify-center mt-10">
        <ul className="space-y-5">
          <li className="flex flex-row align-middle p-2 border border-transparent rounded-lg hover:bg-light-blue">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              className="w-8 h-8 mr-2 my-auto"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
              />
            </svg>
            <Link to="/private/dashboard">
              <span className="text-xl font-bold capitalize text-white">bacheca</span>
            </Link>
          </li>
          {organizzazioniMenuItem()}
          <li className="flex flex-row align-middle p-2 border border-transparent rounded-lg hover:bg-light-blue">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="none"
              className="w-8 h-8 mr-2 my-auto"
            >
              <path
                fillRule="evenodd"
                d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                clipRule="evenodd"
              />
            </svg>
            {/* <Link to="/private/productlist">
              <span className="text-xl font-bold capitalize text-white">prodotti</span>
            </Link> */}
            <Link to="/private/productListV2">
              <span className="text-xl font-bold capitalize text-white">prodotti</span>
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
